module.exports = __webpack_public_path__ + "static/media/loc7_img10.13f4761f.jpg";